module.exports = __webpack_public_path__ + "static/media/adpathy.53d64d69.png";